export enum VisitorAdminBookingOption {
  ONE_SEAT_FULL_DAY = 'ONE_SEAT_FULL_DAY',
}
